<script setup>
/* Imports */
import useGlobalStore from './store/globalStore.js';

/* Store */
const globalStore = useGlobalStore();

/* Set initial state */
globalStore.setInitialState();
</script>

<template>
  <div
    id="app"
    class="app"
  >
    <g-global-styles />
    <router-view v-slot="{ Component }">
      <transition
        name="fade-view"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
